import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAgencyById } from "../../api/agencies";
import toast from "react-hot-toast";
import { Card } from "flowbite-react";

const AgencyDetail = () => {
  const { id } = useParams();
  const [agency, setAgency] = useState(null);

  useEffect(() => {
    const fetchAgency = async () => {
      try {
        const _agency = await getAgencyById(id);

        setAgency(_agency);
      } catch (error) {
        console.error(error);
        toast.error('Error fetching agency');
      }
    }

    fetchAgency();
  }, [id]);

  if (!id || !agency) return null;

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">{agency?.name}</h1>
      </div>
      <div className="p-4">
        <Card>
          <div className="flex flex-col gap-4">
            {agency.logo && (
              <img src={agency.logo} alt={agency.name} className="size-32 object-cover rounded-lg" />
            )}
            <p><span className="font-bold">Bio:</span> {agency.bio}</p>
            <p><span className="font-bold">Address:</span> {agency.address}</p>
            <p><span className="font-bold">Country:</span> {agency.country}</p>
            <p><span className="font-bold">Legal Disclaimer:</span> {agency.legalDisclaimer}</p>
            <p><span className="font-bold">Brand Website:</span> <a href={agency.brandWebsite} target="_blank" rel="nofollow noreferrer">{agency.brandWebsite}</a></p>
            <p><span className="font-bold">Sendpost Subaccount:</span> {agency.sendpostSubaccount}</p>
            <p><span className="font-bold">Sendpost Domain:</span> {agency.sendpostDomain}</p>
          </div>
        </Card>
      </div>
    </>
  )
}

export default AgencyDetail;
